import { apiRequest, guideDetail } from "../../../../services/adapters/base";

class DetailRepository {
	fetchDetail = async (query) => {
		return await apiRequest(
			"get",
			guideDetail,
			{
				params: query,
			},
			true
		);
	};
}

export default DetailRepository;
